module.exports = __webpack_public_path__ + "img/08.762a62ad.png";